export default __webpack_public_path__ + "static/media/smartphone-globo-mais.d1b5dfb1.png";